import classNames from 'classnames';

import { useDesktopOrWider } from '@utils/mediaQuery';
import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsPhotos.sss';

interface Props {
  className?: string,
}

export const ProductDetailsPhotosSkeleton: React.FC<Props> = ({
  className,
}) => {
  const isDesktop = useDesktopOrWider();

  return (
    <div className={classNames(s.root, className)}>
      {isDesktop && (
        <ul className={s.list}>
          {Array(5).fill(null).map((_, i) => (
            <li
              key={i}
              className={s.item}
            >
              <div className={s.photoContainer}>
                <Skeleton className={s.photo} />
              </div>
            </li>
          ))}
        </ul>
      )}

      <div className={s.sliderContainer}>
        <div className={s.photoContainer}>
          <Skeleton className={s.photo} />
        </div>
      </div>
    </div>
  );
};
